import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.match.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.typed-array.uint8-array.js';
import 'core-js/modules/es.typed-array.copy-within.js';
import 'core-js/modules/es.typed-array.every.js';
import 'core-js/modules/es.typed-array.fill.js';
import 'core-js/modules/es.typed-array.filter.js';
import 'core-js/modules/es.typed-array.find.js';
import 'core-js/modules/es.typed-array.find-index.js';
import 'core-js/modules/es.typed-array.for-each.js';
import 'core-js/modules/es.typed-array.includes.js';
import 'core-js/modules/es.typed-array.index-of.js';
import 'core-js/modules/es.typed-array.iterator.js';
import 'core-js/modules/es.typed-array.join.js';
import 'core-js/modules/es.typed-array.last-index-of.js';
import 'core-js/modules/es.typed-array.map.js';
import 'core-js/modules/es.typed-array.reduce.js';
import 'core-js/modules/es.typed-array.reduce-right.js';
import 'core-js/modules/es.typed-array.reverse.js';
import 'core-js/modules/es.typed-array.set.js';
import 'core-js/modules/es.typed-array.slice.js';
import 'core-js/modules/es.typed-array.some.js';
import 'core-js/modules/es.typed-array.sort.js';
import 'core-js/modules/es.typed-array.to-locale-string.js';
import 'core-js/modules/es.typed-array.to-string.js';
import { CID } from 'multiformats/cid';

// Arweave Protocol
var arweaveProtocolPattern = /^(ar):\/\/([^/?#]+)(.*)$/;

// Gateways
var pathGatewayPattern$1 = /^https:\/\/(arweave\.net|arweave\.dev)\/([^/?#]+)(.*)$/;
var subdomainGatewayPattern$1 = /^https:\/\/([^/]+)\.(arweave\.net|arweave\.dev)\/([^/?#]+)(.*)$/;

/**
 * Takes an Arweave URL and returns a formatted Arweave URL if it is valid.
 * _This does not allow paths, query params, or hash in the URL and will return null_.
 * It does not check if the hash is a correct base64 URL encoded SHA-256 hash
 *
 * @param possibleArweaveString A possible URL for an Arweave resource. Can be a gateway or Arweave protocol URL.
 * @returns The formatted Arweave URI with `ar://` protocol and hash. Returns null if the URL is not valid.
 */
var parseArweaveTxId = function parseArweaveTxId(possibleArweaveString) {
  var _possibleArweaveStrin, _possibleArweaveStrin2, _possibleArweaveStrin3, _possibleArweaveStrin4, _possibleArweaveStrin5, _possibleArweaveStrin6;
  if (!possibleArweaveString) {
    return null;
  }
  var arweaveProtocolHash = (_possibleArweaveStrin = possibleArweaveString.match(arweaveProtocolPattern)) === null || _possibleArweaveStrin === void 0 ? void 0 : _possibleArweaveStrin[2];
  var arweaveProtocolUrlIndicators = (_possibleArweaveStrin2 = possibleArweaveString.match(arweaveProtocolPattern)) === null || _possibleArweaveStrin2 === void 0 ? void 0 : _possibleArweaveStrin2[3];
  if (arweaveProtocolHash) {
    return formatReturnHash(arweaveProtocolHash, arweaveProtocolUrlIndicators);
  }
  var subdomainGatewayHash = (_possibleArweaveStrin3 = possibleArweaveString.match(subdomainGatewayPattern$1)) === null || _possibleArweaveStrin3 === void 0 ? void 0 : _possibleArweaveStrin3[3];
  var subdomainGatewayUrlIndicators = (_possibleArweaveStrin4 = possibleArweaveString.match(subdomainGatewayPattern$1)) === null || _possibleArweaveStrin4 === void 0 ? void 0 : _possibleArweaveStrin4[4];
  if (subdomainGatewayHash) {
    return formatReturnHash(subdomainGatewayHash, subdomainGatewayUrlIndicators);
  }
  var pathGatewayHash = (_possibleArweaveStrin5 = possibleArweaveString.match(pathGatewayPattern$1)) === null || _possibleArweaveStrin5 === void 0 ? void 0 : _possibleArweaveStrin5[2];
  var pathGatewayUrlIndicators = (_possibleArweaveStrin6 = possibleArweaveString.match(pathGatewayPattern$1)) === null || _possibleArweaveStrin6 === void 0 ? void 0 : _possibleArweaveStrin6[3];
  if (pathGatewayHash) {
    return formatReturnHash(pathGatewayHash, pathGatewayUrlIndicators);
  }
  return null;
};
var formatReturnHash = function formatReturnHash(hash, urlIndicators) {
  var hashWithUrlIndicators = "".concat(hash).concat(urlIndicators !== null && urlIndicators !== void 0 ? urlIndicators : '');
  return {
    url: "ar://".concat(hashWithUrlIndicators),
    id: hashWithUrlIndicators
  };
};

// IPFS CID (naive check for lack of URL indicators)
var ipfsCidPattern = /^([^/?#]+)$/;

// IPFS Protocol
var ipfsProtocolPattern = /^(ipfs):\/\/([^/?#]+)(.*)$/;

// Gateways
var pathGatewayPattern = /^https?:\/\/[^/]+\/(ipfs)\/([^/?#]+)(.*)$/;
var subdomainGatewayPattern = /^https?:\/\/([^/]+)\.(ipfs)\.[^/?#]+(.*)$/;

/**
 * Takes an IPFS CID or URL and returns a formatted IPFS URL if the CID/URL is valid.
 * _This does not allow paths, query params, or hash in the URL and will return null_.
 *
 * @param possibleIpfsString A possible URL for an IPFS resource. Can be a gateway or IPFS protocol URL.
 * @returns The formatted IPFS URI with protocol and CID. Returns null if the URL is not valid.
 */
var parseCid = function parseCid(possibleIpfsString) {
  var _possibleIpfsString$m, _possibleIpfsString$m2, _possibleIpfsString$m3, _possibleIpfsString$m4, _possibleIpfsString$m5, _possibleIpfsString$m6, _possibleIpfsString$m7;
  if (!possibleIpfsString) {
    return null;
  }
  var ipfsProtocolCid = (_possibleIpfsString$m = possibleIpfsString.match(ipfsProtocolPattern)) === null || _possibleIpfsString$m === void 0 ? void 0 : _possibleIpfsString$m[2];
  var ipfsProtocolUrlIndicators = (_possibleIpfsString$m2 = possibleIpfsString.match(ipfsProtocolPattern)) === null || _possibleIpfsString$m2 === void 0 ? void 0 : _possibleIpfsString$m2[3];
  if (isCid(ipfsProtocolCid)) {
    return formatReturnCid(ipfsProtocolCid, ipfsProtocolUrlIndicators);
  }
  var subdomainGatewayCid = (_possibleIpfsString$m3 = possibleIpfsString.match(subdomainGatewayPattern)) === null || _possibleIpfsString$m3 === void 0 ? void 0 : _possibleIpfsString$m3[1];
  var subdomainGatewayUrlIndicators = (_possibleIpfsString$m4 = possibleIpfsString.match(subdomainGatewayPattern)) === null || _possibleIpfsString$m4 === void 0 ? void 0 : _possibleIpfsString$m4[3];
  if (isCid(subdomainGatewayCid)) {
    return formatReturnCid(subdomainGatewayCid, subdomainGatewayUrlIndicators);
  }
  var pathGatewayCid = (_possibleIpfsString$m5 = possibleIpfsString.match(pathGatewayPattern)) === null || _possibleIpfsString$m5 === void 0 ? void 0 : _possibleIpfsString$m5[2];
  var pathGatewayUrlIndicators = (_possibleIpfsString$m6 = possibleIpfsString.match(pathGatewayPattern)) === null || _possibleIpfsString$m6 === void 0 ? void 0 : _possibleIpfsString$m6[3];
  if (isCid(pathGatewayCid)) {
    return formatReturnCid(pathGatewayCid, pathGatewayUrlIndicators);
  }
  var ipfsCid = (_possibleIpfsString$m7 = possibleIpfsString.match(ipfsCidPattern)) === null || _possibleIpfsString$m7 === void 0 ? void 0 : _possibleIpfsString$m7[1];
  if (isCid(ipfsCid)) {
    return formatReturnCid(ipfsCid);
  }
  return null;
};
var isCid = function isCid(hash) {
  try {
    if (!hash) {
      return false;
    }
    if (typeof hash === 'string') {
      return Boolean(CID.parse(hash));
    }
    if (hash instanceof Uint8Array) {
      return Boolean(CID.decode(hash));
    }
    return Boolean(CID.asCID(hash));
  } catch (_unused) {
    return false;
  }
};
var formatReturnCid = function formatReturnCid(cid, urlIndicators) {
  var cidWithUrlIndicators = "".concat(cid).concat(urlIndicators !== null && urlIndicators !== void 0 ? urlIndicators : '');
  return {
    url: "ipfs://".concat(cidWithUrlIndicators),
    id: cidWithUrlIndicators
  };
};

export { parseCid as a, parseArweaveTxId as p };
